import script from "./AppAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppAlert.vue?vue&type=script&setup=true&lang=ts"

import "./AppAlert.vue?vue&type=style&index=0&id=374c53cd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374c53cd"]])

export default __exports__